import { ContentTop } from "common/src/component/ContentTop";
import { SERVER_SETUP } from "common/src/helpers/constants";
import { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import {
  GameDetailWrapper,
  GameSpinner,
  LobbyWrapper,
} from "common/src/styledComponents/StyledGame";
import config from "../config.json";
import { isMobileOnly } from "react-device-detect";
import React from "react";
import SportsBookCategories from "common/src/component/SportsBookCategories";

const SportsBook = ({
  skin,
  token,
  pages,
  dashboardState,
  player,
  isSE,
  titles,
  firstDeposit,
}) => {
  const [serverSetup] = useState(sessionStorage.getObject(SERVER_SETUP));
  const history = useHistory();

  let playerFirstDeposit = firstDeposit === true || !player;

  useEffect(() => {
    document.title = titles["sports-book"];
  }, [titles]);

  // Set previously received params or direct link hit to a specific page
  const setParamsFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get("page") || "overview";
    const categoryIds = urlParams.get("categoryIds")
      ? urlParams.get("categoryIds").split(",").map(Number)
      : undefined;
    const championshipIds = urlParams.get("championshipIds")
      ? urlParams.get("championshipIds").split(",").map(Number)
      : undefined;
    const eventId = urlParams.get("eventId")
      ? Number(urlParams.get("eventId"))
      : undefined;
    const sportId = urlParams.get("sportId")
      ? Number(urlParams.get("sportId"))
      : undefined;
    const couponType = urlParams.get("couponType")
      ? Number(urlParams.get("couponType"))
      : undefined;
    const maxOdd = urlParams.get("maxOdd")
      ? Number(urlParams.get("maxOdd"))
      : undefined;
    const outrightGroupId = urlParams.get("outrightGroupId")
      ? Number(urlParams.get("outrightGroupId"))
      : undefined;
    const periodType = urlParams.get("periodType")
      ? Number(urlParams.get("periodType"))
      : undefined;
    const virtualSportId = urlParams.get("virtualSportId")
      ? Number(urlParams.get("virtualSportId"))
      : undefined;

    window.altenarWSDK.set({
      page,
      categoryIds,
      championshipIds,
      eventId,
      sportId,
      couponType,
      maxOdd,
      outrightGroupId,
      periodType,
      virtualSportId,
    });
  };

  // Forbiden for SWE players
  useEffect(() => {
    if (player && isSE) {
      window.location.replace(pages["index"]);
    }
  }, [pages, player, isSE]);

  useEffect(() => {
    const loadAltenarWSDK = async () => {
      if (!window.altenarWSDK) {
        console.error("altenarWSDK is not available");
        return;
      }
      await window.altenarWSDK.init({
        integration: config.alternarIntegration,
        culture: "en-GB",
        oddsFormat: "0",
        token: token ? String(token) : undefined,
      });

      window.altenarWSDK.addSportsBook({
        props: {
          onSignInButtonClick: () => {
            window.location.replace(pages["login"]);
          },
          routerType: "memory",
          page: "overview", // Set the default page
          onRouteChange: (data) => {
            const url = new URL(window.location.href);
            url.search = new URLSearchParams(data).toString();
            window.history.pushState(data, "", url);
          },
          onRouterLoad: () => {
            setParamsFromUrl();
          },
          onGoBack: () => {
            history.goBack();
          },
        },
        container: document.getElementById("altenarsportsbook"),
      });
    };

    const handlePopState = () => {
      setParamsFromUrl();
      /* window.location.reload(); */
    };

    window.addEventListener("popstate", handlePopState);
    /* history.listen(handlePopState); */

    loadAltenarWSDK();

    // Cleanup event listeners on unmount
    /* return () => {
      history.listen(() => {});
    }; */
  }, [token, pages, history]);

  return (
    <>
      <ContentTop
        showProfileMenu={false}
        showSearch={true}
        serverSetup={serverSetup}
        gameImagePath={config.gameImagePath}
        defaultLang={config.defaultLang}
        gameCategoryStyleMobile={true}
        skin={skin}
        pages={true}
        gameSearch={true}
        title={isMobileOnly ? "" : "label_sports_book"}
        dashboardState={dashboardState}
      />
      <div id="scroll-to-category-sportsbook"></div>
      <LobbyWrapper sportsbook>
        <SportsBookCategories
          serverSetup={serverSetup}
          skin={skin}
          pages={pages}
        />
        {/* <GameCategoryHeader provider>
            <GameCategoryTitle category>
              {t("label_sport_book", "sport book")}
            </GameCategoryTitle>
          </GameCategoryHeader> */}
        {window.altenarWSDK ? (
          <div id="altenarsportsbook"></div>
        ) : (
          <GameDetailWrapper sb>
            <GameSpinner role="status">
              <span className="sr-only"></span>
            </GameSpinner>
          </GameDetailWrapper>
        )}
      </LobbyWrapper>
    </>
  );
};

export default withRouter(SportsBook);
